import type { NodeEntry } from 'slate'

import type { BufferEditor } from '~publish/legacy/editor/BufferEditor/types.plate'
import { withoutLosingSelection } from '~publish/legacy/editor/helpers/withoutLosingSelection'

import { LinkElement } from '../nodes/LinkElement'

export const toggleShortening = (
  editor: BufferEditor,
  [node, path]: NodeEntry<LinkElement>,
): void => {
  withoutLosingSelection(editor, () => {
    editor.tf.withoutNormalizing(() => {
      const newNode = {
        ...node,
        isShortened: node.shortUrl ? !node.isShortened : false,
      }
      editor.tf.setNodes(newNode, { at: path })

      // editor.tf.insertText is a no-op without a live selection; select the
      // link's own text range first so the replacement actually lands.
      const start = editor.api.start(path)
      const end = editor.api.end(path)
      if (start && end) {
        editor.tf.select({ anchor: start, focus: end })
        editor.tf.insertText(LinkElement.getText(newNode))
      }
    })
  })
}
